import { gql } from 'apollo-boost'

const ABORT_PROBING_SESSION = gql`
  mutation abortProbingSession($id: ID!) {
    abortProbingSession(id: $id) {
      id
      status
    }
  }
`

export default ABORT_PROBING_SESSION
